import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefDropdown,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Dropdown from "../../input/Dropdown";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";
import { User } from "react-feather";
import { itemCreationValidation } from "../../validations/DeductionCreation";
import { FORMS, MODULES } from "../../../const";
import useUserCompany from "../../../hooks/useUserCompany";

const FORM = FORMS.ITEM.TEM.form;

const DeductionItemForm = forwardRef(
  ({ errors, dropdown, isLoading, currentValues, editMode }, ref) => {
    const userCompany = useUserCompany();

    const [company, setCompany] = useState(
      userCompany ? userCompany.comId : null,
    );

    useEffect(() => {
      setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);
    const [itemCreationData, setItemCreationData] = useState(
      editMode
        ? {
            ...currentValues[0],
            temId: currentValues[0].temId,
          }
        : {
            temCode: "",
            temReference: "",
            temCompany: company,
            temType: "",
            temTypeName: "",
            temCategory: "",
            temName: "",
            temPrefix: "",
            temCounter: "",
            temOccurrence: "",
            temDescription: "",
            temCharge: "",
            temSupplier: "",
            temWarranty: "",
            temUnit: "",
            temPrice: "",
            temPackageType: "",
            temExpireDistance: "",
            temDistanceType: "",
            temExpireDuration: "",
            temDurationType: "",
            temStatus: 2,
            temActive: 1,
          },
    );

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);

    // dropdown
    const [itemTypeOpt, setItemTypeOpt] = useState([]);
    const [itemCategoryOpt, setItemCategoryOpt] = useState([]);
    const [itemOccurrenceOpt, setItemOccurrenceOpt] = useState([]);
    const [itemStatusOpt, setItemStatusOpt] = useState([]);
    const [itemActiveOpt, setItemActiveOpt] = useState([]);
    const [itemWarrantyOpt, setItemWarrantyOpt] = useState([]);
    const [distanceType, setDistanceType] = useState([]);
    const [durationType, setDurationType] = useState([]);

    const [initialActive, setInitialActive] = useState(
      editMode ? currentValues?.temActive : 1,
    );

    const [currentErrors, setCurrentErrors] = useState({});
    useEffect(() => {
      setCurrentErrors(errors);
    }, [errors]);

    useEffect(() => {
      if (itemCreationData.temTypeName === "Fuel")
        setItemCreationData((prevState) => ({
          ...prevState,
          temPackageType: 143,
        }));
    }, [itemCreationData]);

    useEffect(() => {
      (async () => {
        //new

        const {
          active,
          status,
          item_type: itemTypeOpt,
          item_category: itemCategoryOpt,
          item_occurrence: itemOccurrenceOpt,
          warranty: warrantyOpt,
          distance_type: distanceTypeOpt,
          duration_type: durationTypeOpt,
        } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
          { key: "item_type" },
          { key: "item_category" },
          { key: "item_occurrence" },
          { key: "warranty" },
          { key: "distance_type" },
          { key: "duration_type" },
        ]);

        setItemTypeOpt(itemTypeOpt);
        setItemCategoryOpt(itemCategoryOpt);
        setItemOccurrenceOpt(itemOccurrenceOpt);
        setItemStatusOpt(status);
        setItemActiveOpt(active);
        setItemWarrantyOpt(warrantyOpt);
        setDistanceType(distanceTypeOpt);
        setDurationType(durationTypeOpt);
      })();
    }, []);

    const getTypeName = async (data) => {
      console.log("data", data);
      const typeName = await getTextByValueAndKey("item_type", data);
      setItemCreationData((prevState) => ({
        ...prevState,
        temTypeName: typeName,
      }));
    };

    useImperativeHandle(ref, () => ({
      getData: () => itemCreationData,
      validateForm: () => {
        return itemCreationValidation(itemCreationData);
      },
      isDeletedActive: () =>
        itemCreationData.temActive === 2 && initialActive !== 2,
      resetForm: () => {
        setItemCreationData({});
        setCurrentErrors({});
      },
    }));

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">Add Item</h4>
              <div className="two fields">
                <Input
                  label="Item code"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_code"
                  editMode={editMode}
                  error={currentErrors.temCode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemCode"
                  value={itemCreationData.temCode}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />

                {/*<Input*/}
                {/*    label="Reference"*/}
                {/*    error={currentErrors.temReference}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {temReference: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    name="itemRefeence"*/}
                {/*    value={itemCreationData.temReference}*/}
                {/*    onChange={(e) => {*/}
                {/*        setItemCreationData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            temReference: e.target.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*/>*/}
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Item Type"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_type"
                  editMode={editMode}
                  error={currentErrors.temType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Item Type"
                  options={itemTypeOpt}
                  style={{ height: "20px" }}
                  value={itemCreationData.temType}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temType: data.value,
                    }));
                    getTypeName(data.value);
                  }}
                />
                <Input
                  label="Item Name"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_name"
                  editMode={editMode}
                  placeholder={"Item Name"}
                  required={true}
                  error={currentErrors.temName}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemName"
                  value={itemCreationData.temName}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temName: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Item Category"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_category"
                  editMode={editMode}
                  error={currentErrors.temCategory}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temCategory: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Item Category"
                  options={itemCategoryOpt}
                  style={{ height: "20px" }}
                  value={itemCreationData.temCategory}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temCategory: data.value,
                    }));
                  }}
                />
                <Input
                  label="Finance Code"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_prefix"
                  editMode={editMode}
                  required={true}
                  placeholder={"Finance Code"}
                  error={currentErrors.temPrefix}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temPrefix: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemPrefix"
                  value={itemCreationData.temPrefix}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temPrefix: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  label="Item Occurrence"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_occurrence"
                  editMode={editMode}
                  error={currentErrors.temOccurrence}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temOccurrence: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Item Occurrence"
                  options={itemOccurrenceOpt}
                  style={{ height: "20px" }}
                  value={itemCreationData.temOccurrence}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temOccurrence: data.value,
                    }));
                  }}
                />

                <Input
                  label="Item Description"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_description"
                  editMode={editMode}
                  placeholder={"Item Description"}
                  error={currentErrors.temDescription}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemDescription"
                  value={itemCreationData.temDescription}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                {/*<Dropdown*/}
                {/*    label="Item Charge"*/}
                {/*    error={currentErrors.temCharge}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {temCharge: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    placeholder="Item Charge"*/}
                {/*    options={itemOccurrenceOpt}*/}
                {/*    style={{height: "20px"}}*/}
                {/*    value={itemCreationData.temCharge}*/}
                {/*    onChange={(e, data) => {*/}
                {/*        setItemCreationData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            temCharge: data.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*/>*/}
                <SearchDropdown
                  key={2}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_charge"
                  multiGrid={true}
                  // multiGridCurrentValue={itemCreationData.temUnit}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temCharge: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temCharge: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "charge_type",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "finance.tms_f_charge_types",
                    primaryKey: "cht_id",
                    fieldName: "cht_charge",
                    id: itemCreationData.temCharge,
                  }}
                  error={currentErrors.temCharge}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temCharge: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Item Charge"
                />
                {/*<Dropdown*/}
                {/*    label="Item Supplier"*/}
                {/*    error={currentErrors.temSupplier}*/}
                {/*    resetError={() =>*/}
                {/*        setCurrentErrors((prevState) => {*/}
                {/*            const {temSupplier: _, ...rest} = prevState;*/}
                {/*            return rest;*/}
                {/*        })*/}
                {/*    }*/}
                {/*    placeholder="Item Supplier"*/}
                {/*    style={{height: "20px"}}*/}
                {/*    value={itemCreationData.temSupplier}*/}
                {/*    onChange={(e, data) => {*/}
                {/*        setItemCreationData((prevState) => ({*/}
                {/*            ...prevState,*/}
                {/*            temSupplier: data.value,*/}
                {/*        }));*/}
                {/*    }}*/}
                {/*    disabled={true}*/}
                {/*/>*/}
                <Dropdown
                  label="Item Warranty"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_warranty"
                  editMode={editMode}
                  error={currentErrors.temWarranty}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temWarranty: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Item Warranty"
                  options={itemWarrantyOpt}
                  style={{ height: "20px" }}
                  value={itemCreationData.temWarranty}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temWarranty: data.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={10}
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_company"
                  multiGrid={true}
                  multiGridCurrentValue={itemCreationData.temCompany}
                  placeholder={"company"}
                  editMode={editMode}
                  clearable={true}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  onResultSelect={(data) =>
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temCompany: data,
                    }))
                  }
                  label="Company"
                  error={currentErrors.temCompany}
                  resetError={() =>
                    setItemCreationData((prevState) => {
                      const { temCompany: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  disabled={true}
                />

                <SearchDropdown
                  key={2}
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_package_type"
                  required={itemCreationData.temTypeName !== "Fuel"}
                  editMode={editMode}
                  // multiGrid={true}
                  // multiGridCurrentValue={itemCreationData.temUnit}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temPackageType: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temPackageType: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "package_type",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_package_type",
                    primaryKey: "pkg_id",
                    fieldName: "pkg_name",
                    id: itemCreationData.temPackageType,
                  }}
                  error={currentErrors.temPackageType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temPackageType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Default Package Type (ex: CASE, PACKAGES, BOX, Bottle)"
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={2}
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_unit"
                  required={true}
                  editMode={editMode}
                  multiGrid={true}
                  // multiGridCurrentValue={itemCreationData.temUnit}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temUnit: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temUnit: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "unit_type",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_units",
                    primaryKey: "uni_id",
                    fieldName: "uni_name",
                    id: itemCreationData.temUnit,
                  }}
                  error={currentErrors.temUnit}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temUnit: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Default Unit (ex: KM, LTRS, TONS, HOUSE)"
                />
                <Input
                  type={"number"}
                  step={"0.01"}
                  label="Unit Price"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_price"
                  editMode={editMode}
                  required={true}
                  placeholder={"Unit Price"}
                  min={0.1}
                  error={currentErrors.temPrice}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temPrice: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="unitPrice"
                  value={itemCreationData.temPrice}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temPrice: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  type={"number"}
                  label="Expire (Distance)"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_expire_distance"
                  editMode={editMode}
                  placeholder={"Distance"}
                  min={0}
                  error={currentErrors.temExpireDistance}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temExpireDistance: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemCharge"
                  value={itemCreationData.temExpireDistance}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temExpireDistance: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  label="Distance Type"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_distance_type"
                  editMode={editMode}
                  error={currentErrors.temDistanceType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temDistanceType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={distanceType}
                  placeholder="Distance Type"
                  style={{ height: "20px" }}
                  value={itemCreationData.temDistanceType}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temDistanceType: data.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Input
                  type={"number"}
                  label="Expire (Duration)"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_expire_duration"
                  editMode={editMode}
                  placeholder={"Duration"}
                  min={0}
                  error={currentErrors.temExpireDuration}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temExpireDuration: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="itemCharge"
                  value={itemCreationData.temExpireDuration}
                  onChange={(e) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temExpireDuration: e.target.value,
                    }));
                  }}
                />
                <Dropdown
                  label="Duration Type"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_duration_type"
                  editMode={editMode}
                  error={currentErrors.temDurationType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temDurationType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={durationType}
                  placeholder="Item Supplier"
                  style={{ height: "20px" }}
                  value={itemCreationData.temDurationType}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temDurationType: data.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_status"
                  editMode={editMode}
                  error={currentErrors.temStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={itemStatusOpt}
                  value={itemCreationData.temStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temStatus: data.value,
                    }));
                  }}
                />

                <Dropdown
                  required={true}
                  label="Active"
                  module={MODULES.Master}
                  form={FORM}
                  field="tem_active"
                  authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  error={currentErrors.temActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { temActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={itemActiveOpt}
                  value={itemCreationData.temActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setItemCreationData((prevState) => ({
                      ...prevState,
                      temActive: data.value,
                    }));
                  }}
                />
              </div>
            </div>
            {editMode && (
              <InfoList
                title="User Information"
                content={[
                  {
                    title: "Created By",
                    value: itemCreationData.createdBy
                      ? itemCreationData.createdBy
                      : "N/A",
                  },
                  {
                    title: "Created Date",
                    value: itemCreationData.createdDate
                      ? formatFromJsonDate(itemCreationData.createdDate)
                      : "N/A",
                  },
                  {
                    title: "Last Modified By",
                    value: itemCreationData.lastModifiedBy
                      ? itemCreationData.lastModifiedBy
                      : "N/A",
                  },
                  {
                    title: "Last Modified Date",
                    value: itemCreationData.lastModifiedDate
                      ? formatFromJsonDate(itemCreationData.lastModifiedDate)
                      : "N/A",
                  },
                ]}
                Icon={User}
              />
            )}
          </form>
        )}
      </>
    );
  },
);
export default DeductionItemForm;
